if (!customElements.get('slider-component')) {
  customElements.define('slider-component', class SliderComponent extends HTMLElement {
    constructor() {
      super();
      
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      // Handle orientation based on viewport and data attribute
      this.oriantation = window.matchMedia('(min-width: 768px)').matches && this.dataset.oriantation 
        ? this.dataset.oriantation 
        : 'horizontal';

      // Set position properties based on orientation
      if (this.oriantation == 'vertical') {
        this.offsetPosition = 'offsetTop';
        this.scrollPosition = 'scrollTop';
        this.clientPosition = 'clientHeight';
      } else {
        this.offsetPosition = 'offsetLeft';
        this.scrollPosition = 'scrollLeft';
        this.clientPosition = 'clientWidth';
      }

      if (!this.slider || !this.nextButton) return;

      this.initPages();
      
      const resizeObserver = new ResizeObserver((entries) => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(
        element => element[this.clientPosition] > 0
      );

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1][this.offsetPosition] - 
                             this.sliderItemsToShow[0][this.offsetPosition];
      
      this.slidesPerPage = Math.floor(
        (this.slider.clientHeight - this.sliderItemsToShow[0][this.offsetPosition]) / this.sliderItemOffset
      );
      
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      
      this.update();
    }

    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }

    update() {
      if (!this.slider || !this.nextButton) return;

      const previousPage = this.currentPage;
      const sliderPosition = this.slider[this.scrollPosition];
      
      this.currentPage = Math.round(sliderPosition / this.sliderItemOffset) + 1;

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1]
            }
          })
        );
      }

      if (this.enableSliderLooping) return;

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && sliderPosition === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider[this.clientPosition] + 
                              this.slider[this.scrollPosition] - offset;
      
      return (
        element[this.offsetPosition] + element[this.clientPosition] <= lastVisibleSlide && 
        element[this.offsetPosition] >= this.slider[this.scrollPosition]
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      const sliderPosition = this.slider[this.scrollPosition];
      
      this.slideScrollPosition = event.currentTarget.name === 'next'
        ? sliderPosition + step * this.sliderItemOffset
        : sliderPosition - step * this.sliderItemOffset;
      
      this.setSlidePosition(this.slideScrollPosition);
    }

    setSlidePosition(position) {
      const param = this.oriantation == 'vertical' 
        ? { 
            top: position,
            behavior: 'smooth'  // Added smooth scrolling
          }
        : { 
            left: position,
            behavior: 'smooth'  // Added smooth scrolling
          };
        
      this.slider.scrollTo(param);
    }
  });
}